var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('router-view',{staticClass:"opc-page",class:{
    'opc-page-mobile': _vm.$context.is.mobile,
    'opc-page-desktop': _vm.$context.is.desktop,
    'opc-page-tablet': _vm.$context.is.tablet,
  }}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }